export default __webpack_public_path__ + "static/turkeys-6024999c28b18435b80ed01379146b38.webp";